import { sb } from '../supabase';

// The trader's contact phone for a request — ADMIN-ONLY since 2026-09-28.
//
// requests.contact_phone is moved on insert into public.request_contacts by
// trg_requests_move_contact_phone and blanked on the requests row
// (supabase/migrations/20260929010000_contact_phone_admin_only.sql). RLS on request_contacts
// admits admins only; the admin screens read it through this helper.
//
// WORKS IN EITHER DEPLOY ORDER. Before that SQL is applied the table does not
// exist: the read fails, this returns {}, and the caller falls back to
// requests.contact_phone, which is still populated then. After it is applied,
// the column is NULL and the phone comes from here. So the web can ship before
// or after the SQL without an admin screen ever losing the number.
//
// Returns { [request_id]: phone }.
export async function fetchContactPhones(requestIds) {
  const ids = [...new Set((requestIds || []).filter(Boolean))];
  if (!ids.length) return {};
  const { data, error } = await sb
    .from('request_contacts')
    .select('request_id, contact_phone')
    .in('request_id', ids);
  if (error) {
    // Expected before the migration is applied (relation does not exist).
    console.error('[requestContacts] read failed:', error.code || '', error.message || error);
    return {};
  }
  return Object.fromEntries((data || []).map((r) => [r.request_id, r.contact_phone]));
}

// Overlay the admin-only phone onto request rows, so a screen keeps reading
// `row.contact_phone` exactly as before.
export async function withContactPhones(rows) {
  const list = Array.isArray(rows) ? rows : [];
  const phones = await fetchContactPhones(list.map((r) => r?.id));
  return list.map((r) => (r ? { ...r, contact_phone: phones[r.id] || r.contact_phone || null } : r));
}
